// covered-by: frontends/carrie/src/ask-v2/pages/__tests__/AskV2ProjectPage.test.tsx
import { useEffect, useRef } from "react";

import { type AskV2ReviewProgressMode } from "./collectRailContent";
import { type AskV2RailSectionId } from "./types";

export function useAskV2RailReviewAutoOpen(input: {
  mode: AskV2ReviewProgressMode;
  setRailOpen: (open: boolean) => void;
  setSectionOpen: (
    updater: (
      current: Record<AskV2RailSectionId, boolean>,
    ) => Record<AskV2RailSectionId, boolean>,
  ) => void;
}): void {
  const prevModeRef = useRef(input.mode);

  useEffect(() => {
    if (input.mode === "running" && prevModeRef.current !== "running") {
      input.setRailOpen(true);
      input.setSectionOpen((current) => ({ ...current, progress: true }));
    }
    prevModeRef.current = input.mode;
  }, [input.mode, input.setRailOpen, input.setSectionOpen]);
}
